import React, { useState } from 'react';
import './ContractualTransportation.css'; // Assuming you save the CSS in Agreement.css
import razitko from '../../../img/razitko.png'
import Button from 'react-bootstrap/Button';
import fetchData from '../../../function/fetchData'
import SignatureColumn from './SignatureColumn';
import Spinner from 'react-bootstrap/Spinner';

const ContractualTransportation = ({ server, token, data, tokenOfContract, alreadySigned, handleDone, setShowMessage }) => {
  const type = 'contractualTransportation';
  const serverAddress = server + "api2/contractController.php";
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [formData, setFormData] = useState({
    prepravceFirma: data ? data.prepravceFirma : 'Vaněček Marek, Vítězslava Nezvala 4281, Chomutov 430 01, Ic: 09286543',
    objednatelFirma: data ? data.objednatelFirma : '',

    price: data ? data.price : 0,
    vzdalenost: data ? data.vzdalenos : 0,
    splatnost: data ? data.splatnost : '0',
    date: data ? data.date : '',
    pokuta: data ? data.pokuta : 400
  });

  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Odeslat
  const handleSubmit = (e) => {
    e.preventDefault();
    const json = JSON.stringify(formData);

    if (json && email.length > 5) {
      setLoading(true);
      fetchData(serverAddress, {
        token: token,
        action: 'SAVE',
        type: type,
        formData: formData,
        email: email
      }).then((res) => {
        setShowMessage('Smlouva byla odeslána.');
        setLoading(false);
      })
    } else {
      alert('vyplňte email');
    }
  };

  // Uloží podpis
  const sendSignatureToServer = async (dataUrl) => {
    const serverAddress = `${server}api2/saveSignatureController.php`;
    try {
      const response = await fetch(serverAddress, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: "SAVE_SIGNATURE",
          payload: {
            tokenOfContract: tokenOfContract,
            signature: dataUrl
          }
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();
      console.log('Signature saved:', result);
      handleDone();
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="agreement" style={{ marginTop: 20 }}>
      <div>
        <h1>Smlouva o smluvní přepravě osob</h1>
        <br></br>
        <br></br>
        <h2>1. Smluvní strany</h2>
        <br></br>
        <h3>1.1. Přepravce</h3>
        <p>
          Společnost:
        </p>
        <input
            type="text"
            name="prepravceFirma"
            value={formData.prepravceFirma}
            onChange={handleChange}
            className='niceInput'
            style={{width: '100%'}}
         />
        <br></br><br></br>
        <h3>1.2. Objednatel</h3>
        <p>
          Společnost:
        </p>
        <input
            type="text"
            name="objednatelFirma"
            value={formData.objednatelFirma}
            onChange={handleChange}
            className='niceInput'
            style={{width: '100%'}}
          /><br />
        <br></br>

        <h2>2. Předmět smlouvy</h2>
        <p>
          2.1. Předmětem této smlouvy je zajištění přepravy osob (dále jen "přeprava") pro Objednatele na základě jeho objednávek, a to v rozsahu, způsobu a za podmínek dále specifikovaných.
        </p>
        <p>
          2.2. Přeprava bude realizována na základě jednotlivých objednávek Objednatele, které budou obsahovat specifikaci trasy, termíny, počet přepravovaných osob a další potřebné údaje.
        </p>
        <br></br>
        <h2>3. Povinnosti a práva smluvních stran</h2>
        <p><strong>3.1. Přepravce se zavazuje:</strong></p>
        <ul>
          <li>Zajistit přepravu osob v souladu s objednávkami Objednatele.</li>
          <li>Dodržovat veškeré právní předpisy týkající se přepravy osob, včetně zajištění bezpečnosti a pohodlí přepravovaných osob.</li>
          <li>Poskytnout kvalifikované a zodpovědné řidiče, kteří mají veškeré potřebné oprávnění a zkušenosti.</li>
          <li>Poskytnout vozidla v odpovídajícím technickém stavu, která splňují všechny právní požadavky.</li>
        </ul>

        <p><strong>3.2. Objednatel se zavazuje:</strong></p>
        <ul>
          <li>Poskytovat přesné a pravdivé informace v objednávkách, zejména co se týče počtu osob, tras a termínů přepravy.</li>
          <li>Zajistit včasné informování Přepravce o jakýchkoli změnách.</li>
        </ul>
        <br></br>

        <h2>4. Cena za dopravu a vzdálenost</h2>
        <p>
          4.1. Cena za přepravu činí: 
          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
            className='niceInput'
            style={{width: 80}}
          /> Kč
        </p>
        <p>
            4.2. Splatnost do
          <input
            type="text"
            name="splatnost"
            value={formData.splatnost}
            onChange={handleChange}
            className='niceInput'
          />, v případě, že objednatel nezaplatí do uvedeného termína, bude objednavateli vystavena smluvní pokuta <input
            type="text"
            name="splatnost"
            value={formData.pokuta}
            onChange={handleChange}
            className='niceInput'
            style={{width: 80}}
          /> Kč. Ta se musí uhradit do 14 dní od vystavení, v opačném případě smlouva zaniká.
        
        </p>
        <p>
          4.3. Vzdálenost přepravy je: 
          <input
            type="number"
            name="vzdalenost"
            value={formData.vzdalenost}
            onChange={handleChange}
            className='niceInput'
            style={{width: 80}}
          /> km
        </p>

        <br></br>
        <h2>5. Závěrečná ustanovení</h2>
        <p>
          5.1. Tato smlouva je platná a účinná ode dne jejího podpisu oběma smluvními stranami.
        </p>
        <p>
          5.2. Smlouva je vyhotovena ve dvou vyhotoveních, přičemž každá strana obdrží jedno vyhotovení.
        </p>
        <br></br>

        <div className="signatures">
          <p>V Chomutově dne: 
            <input 
              type='text' 
              className='niceInput' 
              name='date' 
              value={formData.date} 
              onChange={handleChange} 
              readOnly={alreadySigned ? true : false} 
            />
          </p>
          <br />
          <br />
          {alreadySigned && <img src={razitko} style={{ width: 300 }} />}
          <p>________________________________</p>
          <p>Zaměstanavatel: Vaněček Marek</p>

          <br /><br />
          {!alreadySigned && tokenOfContract && <SignatureColumn sendSignatureToServer={sendSignatureToServer} />}
          {alreadySigned && <img src={server + 'api2/public/signature/' + tokenOfContract + '.png'} />}
          <p>Objednatel</p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {!tokenOfContract && 
            <input 
              type='text' 
              className='niceInput' 
              placeholder='email' 
              name='email' 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
            />
          }
          {!tokenOfContract && !loading && <Button variant="success" onClick={handleSubmit}>Odeslat</Button>}
          {!tokenOfContract && loading && <Button variant="secondary">Odesílám <Spinner animation="border" size='sm' /></Button>}
        </div>
      </div>
    </div>
  );
}

export default ContractualTransportation;


